module.exports = __webpack_public_path__ + "static/media/invite-gray.aa5390c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dealroom-icons/invite-gray.svg
// module id = 2382
// module chunks = 0